<script setup lang="ts">
import {
  UserIcon,
  ShoppingCartIcon,
  CheckCircleIcon,
  HomeIcon,
} from "@heroicons/vue/24/outline";
import { onMounted } from "vue";

// Using the global React Native detection plugin instead of window object check

const commerceStore = useCommerceStore();
const { totalItemsInCart } = storeToRefs(commerceStore);

// Use the global React Native detection plugin
const { $reactNative } = useNuxtApp();

onMounted(() => {
  // Using the React Native plugin for detection
  console.log(
    "MobileBottom: Using React Native plugin detection:",
    $reactNative.isApp
  );
});
</script>

<template>
  <!-- Mobile Bottom Navigation - Standard implementation used in production apps worldwide -->
  <!-- Wrap in client-only to prevent hydration mismatches -->
  <client-only>
    <div v-if="!$reactNative.isApp" class="mobile-bottom-nav">
    <!-- Navigation Menu -->
    <div
      style="
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: space-evenly;
        align-items: center;
      "
    >
      <a
        href="/"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          flex: 1;
        "
      >
        <HomeIcon style="width: 28px; height: 28px; color: white" />
        <span style="font-size: 12px; color: white; margin-top: 2px">Home</span>
      </a>
      <a
        href="/sim-activation"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          flex: 1;
        "
      >
        <CheckCircleIcon style="width: 28px; height: 28px; color: white" />
        <span style="font-size: 12px; color: white; margin-top: 2px"
          >Activate</span
        >
      </a>
      <a
        href="/cart"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          flex: 1;
          position: relative;
        "
      >
        <ShoppingCartIcon style="width: 28px; height: 28px; color: white" />
        <div v-if="totalItemsInCart > 0" class="cart-count">
          {{ totalItemsInCart }}
        </div>
        <span style="font-size: 12px; color: white; margin-top: 2px">Cart</span>
      </a>
      <a
        href="/account/dashboard?view=my-plans"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          flex: 1;
        "
      >
        <UserIcon style="width: 28px; height: 28px; color: white" />
        <span style="font-size: 12px; color: white; margin-top: 2px"
          >Account</span
        >
      </a>
    </div>
  </div>
  </client-only>
</template>
<style scoped>
/* Ensure mobile footer is only visible on mobile screens */
.mobile-bottom-nav {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #9900f1;
  z-index: 999;
}

/* Hide on larger screens */
@media (min-width: 768px) {
  .mobile-bottom-nav {
    display: none !important;
  }
}

.cart-count {
  position: absolute;
  top: 22px;
  right: 50%;
  margin-right: 30px;
  margin-top: -10px;
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style scoped lang="scss">
.cart-count {
  @apply absolute top-2 -right-2 text-white text-xs bg-black rounded-full w-5 h-5 flex justify-center items-center;
}

.mobile-bottom-nav {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: 60px !important;
  z-index: 999999 !important;
  background-color: #9900f1 !important;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.15) !important;

  @media (min-width: 768px) {
    display: none !important;
    visibility: hidden !important;
  }
}
</style>
